/* eslint-disable security/detect-object-injection */
import { Loader, withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useActivityUtil } from 'ent-capability-hooks';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import cx from 'classnames';
import { ActivitiesService } from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import gatewayMessages from 'gw-capability-gateway-react/gateway.messages';
import ActivityTableComponent from '../components/ActivityTableComponent/ActivityTableComponent';
import ActivityAdvancedFilter from '../components/AdvancedFilter/ActivityAdvancedFilter';
import messages from './Activities.messages';
import metadata from './Activities.metadata.json5';
import styles from './Activities.module.scss';

const tableHeadings = {
    yourOpenActivityTile: messages.yourOpen,
    yourCompletedActivityTile: messages.yourComplete,
    createdByYouActivityTile: messages.createdByYou,
    allOpenActivityTile: messages.allOpen,
    allCompletedActivityTile: messages.allCompleted,
    allCancelledActivityTile: messages.allCanceled,
    allUnassignedActivityTile: messages.allUnassigned,
    advancedFilter: messages.activities,
};

class Activities extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        activitiesResult: [],
        activitiesYourCompleteCount: 0,
        activitiesYourOpenCount: 0,
        activitiesAllOpenCount: 0,
        activitiesCreatedByYouCount: 0,
        activitiesAllCompletedCount: 0,
        activitiesCanceledCount: 0,
        activitiesUnassignedCount: 0,
        activitiesComplete: [],
        activitiesFuture: [],
        activitiesOverdue: [],
        activitiesThisWeek: [],
        activitiesToday: [],
        activitiesTomorrow: [],
        yourOpenActivityTileStatus: false,
        yourCompletedActivityTileStatus: false,
        createdByYouActivityTileStatus: false,
        allOpenActivityTileStatus: false,
        allCompletedActivityTileStatus: false,
        allCancelledActivityTileStatus: false,
        allUnassignedActivityTileStatus: false,
        displayNoActivities: false,
        toggleAdvancedFilter: true,
        currentView: 'yourOpenActivityTile',
        isLoading: true,
        publicId: '',
        searchFilter: '',
    };

    componentDidMount() {
        this.getActivitySummaries();
    }

    getActivitySummaries = async () => {
        const { authHeader } = this.props;

        ActivitiesService.getActivitySummariesForCurrentUserAndGroups_TWIA(authHeader).then(
            response => {
                
                const activities = _.map(response, activity => _.extend({}, activity, { expanded: false, assignableUsers: null }));

                this.setState(
                    {
                        activitiesResult: activities,
                        isLoading: false,
                    },
                    () => {
                        this.handleOnClick('yourOpenActivityTile','');
                        this.getTilesCount(activities);
                    }
                );
            }
        );
    };
   
    handleFilterChange = (value) => {
         const  { currentView } = this.state;

            this.setState(
            {
                searchFilter: value,
            });

        this.handleOnClick(currentView,value);
    };

    getTilesCount = activitiesData => {
        const activitiesYourCompleteCount = activitiesData.filter(
            activitiesInfo => (
                    activitiesInfo.status === 'complete' &&
                    activitiesInfo.isAssignedToCurrentUser
                )
        );
        
        const activitiesYourOpenCount = activitiesData.filter(
            activitiesInfo => (
                    activitiesInfo.status === 'open' &&
                    activitiesInfo.isAssignedToCurrentUser
                )
        );
        
        const activitiesCanceledCount = activitiesData.filter(
            activitiesInfo => activitiesInfo.status === 'canceled'
        );
        
        const activitiesAllCompletedCount = activitiesData.filter(
            activitiesInfo => activitiesInfo.status === 'complete'
        );
        
        const activitiesAllOpenCount = activitiesData.filter(activitiesInfo => activitiesInfo.status === 'open');
        
        const activitiesCreatedByYouCount = activitiesData.filter(
            activitiesInfo => activitiesInfo.isCreatedByCurrentUser
        );
        
        const activitiesUnassignedCount = activitiesData.filter(activitiesInfo =>activitiesInfo.status === 'unassigned');

        this.setState({
            activitiesYourCompleteCount: activitiesYourCompleteCount.length,
            activitiesYourOpenCount: activitiesYourOpenCount.length,
            activitiesAllOpenCount: activitiesAllOpenCount.length,
            activitiesCreatedByYouCount: activitiesCreatedByYouCount.length,
            activitiesAllCompletedCount: activitiesAllCompletedCount.length,
            activitiesCanceledCount: activitiesCanceledCount.length,
            activitiesUnassignedCount: activitiesUnassignedCount.length,
        });
    };

    createNote = async (data, publicID) => {
        const { authHeader, modalContext } = this.props;
        const { activitiesResult, currentView } = this.state;
        const activityNoteData = await ActivitiesService.createNoteForActivity(
            publicID,
            data,
            authHeader
        );

        if (!_.isUndefined(activityNoteData)) {
            modalContext
                .showAlert({
                    title: gatewayMessages.noteCreated,
                    message: gatewayMessages.noteCreatedSuccessfully,
                    status: 'success',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                })
                .then(() => {
                    const activityObj = activitiesResult.find(
                        obj => obj.publicID === publicID
                    );

                    activityObj.notes.push(activityNoteData);
                    this.handleOnClick(currentView,'');
                }, _.noop);
        }
    };

    onClickComplete = data => {
        const { activitiesResult } = this.state;
        const { authHeader } = this.props;
        const activityIndex = activitiesResult.findIndex(
            obj => obj.publicID === data
        );
        
        ActivitiesService.markActivityAsCompleted(data, authHeader).then(
            completeActivity => {
                activitiesResult[activityIndex].status = completeActivity.status;
                activitiesResult[activityIndex].closeDate = completeActivity.closeDate;
                activitiesResult[activityIndex].completedDate = completeActivity.completedDate;
                activitiesResult[activityIndex].canComplete = false;
                this.setState({
                    publicId: data,
                    activitiesResult,
                });
                this.getTilesCount(activitiesResult);
            }
        );
    };

    handleFilterClick = () => {
        const { toggleAdvancedFilter, currentView } = this.state;

        this.setState({ toggleAdvancedFilter: !toggleAdvancedFilter });
        this.handleOnClick(currentView,'');
    };

    handleCustomFilterClick = activities => {
        const { activitiesFutureAdvanceData, activitiesOverdueAdvanceData, activitiesTodayAdvanceData, activitiesTomorrowAdvanceData, activitiesCompleteData, activitiesThisWeekAdvanceData} = useActivityUtil();
        const activitiesData = activities;
        let activitiesOverdue = [];
        let activitiesFuture = [];
        let activitiesToday = [];
        let activitiesComplete = [];
        let activitiesThisWeek = [];
        let activitiesTomorrow = [];

        activitiesFuture = activitiesFutureAdvanceData(activitiesData);
        activitiesOverdue = activitiesOverdueAdvanceData(activitiesData);
        activitiesToday = activitiesTodayAdvanceData(activitiesData);
        activitiesTomorrow = activitiesTomorrowAdvanceData(activitiesData);
        activitiesComplete = activitiesCompleteData(activitiesData);
        activitiesThisWeek = activitiesThisWeekAdvanceData(activitiesData);
        
        if (
            activitiesOverdue.length === 0 &&
            activitiesToday.length === 0 &&
            activitiesFuture.length === 0 &&
            activitiesComplete.length === 0 &&
            activitiesTomorrow.length === 0 &&
            activitiesThisWeek.length === 0
        ) {
            this.setState({
                displayNoActivities: true,
                activitiesOverdue,
                activitiesToday,
                activitiesFuture,
                activitiesComplete,
                activitiesThisWeek,
                activitiesTomorrow,
            });
        } else {
            this.setState({
                activitiesOverdue: _.sortBy(activitiesOverdue, 'dueDate'),
                activitiesToday: _.sortBy(activitiesToday, 'dueDate'),
                activitiesFuture: _.sortBy(activitiesFuture, 'dueDate'),
                activitiesComplete: _.sortBy(activitiesComplete, 'dueDate'),
                activitiesThisWeek: _.sortBy(activitiesThisWeek, 'dueDate'),
                activitiesTomorrow: _.sortBy(activitiesTomorrow, 'dueDate'),
                displayNoActivities: false,
            });
        }
    };
    
    handleOnClick = (id,searchValue) => {
        const { activitiesResult: activitiesResponse } = this.state;
        const {  filterActivitiesByValue } = useActivityUtil();

        let tempActivitiesResult = [...activitiesResponse ];

        // on switch between tiles change expanded as false
        const updateExpandedActivities = (list) => list.map((obj) => {
            if (obj.expanded === true) {
              // Update expanded to false
              return { ...obj, expanded: false };
            }
  
            return obj;
          });

        tempActivitiesResult = updateExpandedActivities(tempActivitiesResult);

        if(searchValue){
            tempActivitiesResult = filterActivitiesByValue(tempActivitiesResult, searchValue);
        }

        let activitiesOverdue = [];
        let activitiesFuture = [];
        let activitiesToday = [];
        let activitiesComplete = [];
        let activitiesThisWeek = [];
        let activitiesTomorrow = [];
        let yourOpenActivityTile = false;
        let yourCompletedActivityTile = false;
        let createdByYouActivityTile = false;
        let allOpenActivityTile = false;
        let allCompletedActivityTile = false;
        let allCancelledActivityTile = false;
        let allUnassignedActivityTile = false;
        const activityUndefinedOverdue = [];
        const activitiesData = [];
        let activityOverdue = [];

        tempActivitiesResult.forEach(activitiesInfo => {
            if (
                _.isUndefined(activitiesInfo.dueDate) &&
                activitiesInfo.status !== 'complete'
            ) {
                activityUndefinedOverdue.push(activitiesInfo);
            } else {
                activitiesData.push(activitiesInfo);
            }
        });
        
        const isAssignedToCurrentUserData = activitiesData.filter(
            activitiesInfo => activitiesInfo.isAssignedToCurrentUser
        );
        
        const isCreatedByCurrentUserData = activitiesData.filter(
            activitiesInfo => activitiesInfo.isCreatedByCurrentUser
        );
        const {activitiesCompleteData, activitiesThisWeekData, activitiesThisWeekAdvanceData, activitiesFutureData, activitiesFutureAdvanceData, activitiesTomorrowData, activitiesTomorrowAdvanceData, activitiesTodayData, activitiesTodayAdvanceData, activitiesOverdueData, activitiesOverdueAdvanceData } = useActivityUtil();
        
        switch (id) {
            case 'yourOpenActivityTile':
                activitiesFuture = activitiesFutureData(
                    isAssignedToCurrentUserData,
                    'open'
                );
                activitiesOverdue = activitiesOverdueData(
                    isAssignedToCurrentUserData,
                    'open'
                );
                activitiesToday = activitiesTodayData(
                    isAssignedToCurrentUserData,
                    'open'
                );
                activitiesThisWeek = activitiesThisWeekData(
                    isAssignedToCurrentUserData,
                    'open'
                );
                activitiesTomorrow = activitiesTomorrowData(
                    isAssignedToCurrentUserData,
                    'open'
                );
                activityOverdue = activityUndefinedOverdue.filter(
                    activitiesInfo => (
                            activitiesInfo.isAssignedToCurrentUser &&
                            activitiesInfo.status === 'open'
                        )
                );
                yourOpenActivityTile = true;
                break;
            case 'yourCompletedActivityTile':
                activitiesComplete = activitiesCompleteData(
                    isAssignedToCurrentUserData
                );
                yourCompletedActivityTile = true;
                break;
            case 'createdByYouActivityTile':
                activitiesFuture = activitiesFutureAdvanceData(
                    isCreatedByCurrentUserData
                );
                activitiesOverdue = activitiesOverdueAdvanceData(
                    isCreatedByCurrentUserData
                );
                activitiesToday = activitiesTodayAdvanceData(
                    isCreatedByCurrentUserData
                );
                activitiesTomorrow = activitiesTomorrowAdvanceData(
                    isCreatedByCurrentUserData
                );
                activitiesComplete = activitiesCompleteData(
                    isCreatedByCurrentUserData
                );
                activitiesThisWeek = activitiesThisWeekAdvanceData(
                    isCreatedByCurrentUserData
                );
                activityOverdue = activityUndefinedOverdue.filter(
                    activitiesInfo => activitiesInfo.isCreatedByCurrentUser
                );
                createdByYouActivityTile = true;
                break;
            case 'allOpenActivityTile':
                activitiesFuture = activitiesFutureData(
                    activitiesData,
                    'open'
                );
                activitiesOverdue = activitiesOverdueData(
                    activitiesData,
                    'open'
                );
                activitiesToday = activitiesTodayData(
                    activitiesData,
                    'open'
                );
                activitiesThisWeek = activitiesThisWeekData(
                    activitiesData,
                    'open'
                );
                activitiesTomorrow = activitiesTomorrowData(
                    activitiesData,
                    'open'
                );
                activityOverdue = activityUndefinedOverdue.filter(
                    activitiesInfo => activitiesInfo.status === 'open'
                );
                allOpenActivityTile = true;
                break;
            case 'allCompletedActivityTile':
                activitiesComplete =
                    activitiesCompleteData(activitiesData);
                allCompletedActivityTile = true;
                break;
            case 'allCancelledActivityTile':
                activitiesFuture = activitiesFutureData(
                    activitiesData,
                    'canceled'
                );
                activitiesOverdue = activitiesOverdueData(
                    activitiesData,
                    'canceled'
                );
                activitiesToday = activitiesTodayData(
                    activitiesData,
                    'canceled'
                );
                activitiesTomorrow = activitiesTomorrowData(
                    activitiesData,
                    'canceled'
                );
                activitiesThisWeek = activitiesThisWeekData(
                    activitiesData,
                    'canceled'
                );
                activityOverdue = activityUndefinedOverdue.filter(
                    activitiesInfo => activitiesInfo.status === 'canceled'
                );
                allCancelledActivityTile = true;
                break;
            case 'allUnassignedActivityTile':
                    activitiesFuture = activitiesFutureData(
                        activitiesData,
                        'unassigned'
                    );
                    activitiesOverdue = activitiesOverdueData(
                        activitiesData,
                        'unassigned'
                    );
                    activitiesToday = activitiesTodayData(
                        activitiesData,
                        'unassigned'
                    );
                    activitiesTomorrow = activitiesTomorrowData(
                        activitiesData,
                        'unassigned'
                    );
                    activitiesThisWeek = activitiesThisWeekData(
                        activitiesData,
                        'unassigned'
                    );
                    activityOverdue = activityUndefinedOverdue.filter(
                        activitiesInfo => activitiesInfo.status === 'unassigned'
                    );
                    allUnassignedActivityTile = true;
                    break;
            default:
                break;
        }

        activitiesOverdue = activityOverdue.concat(
            _.sortBy(activitiesOverdue, 'dueDate')
        );
        
        if (
            activitiesOverdue.length === 0 &&
            activitiesToday.length === 0 &&
            activitiesFuture.length === 0 &&
            activitiesThisWeek.length === 0 &&
            activitiesComplete.length === 0 &&
            activitiesTomorrow.length === 0
        ) {
            this.setState({
                displayNoActivities: true,
                activitiesOverdue,
                activitiesToday,
                activitiesFuture,
                activitiesComplete,
                activitiesThisWeek,
                activitiesTomorrow,
                yourOpenActivityTileStatus: yourOpenActivityTile,
                yourCompletedActivityTileStatus: yourCompletedActivityTile,
                createdByYouActivityTileStatus: createdByYouActivityTile,
                allOpenActivityTileStatus: allOpenActivityTile,
                allCompletedActivityTileStatus: allCompletedActivityTile,
                allCancelledActivityTileStatus: allCancelledActivityTile,
                allUnassignedActivityTileStatus: allUnassignedActivityTile,
            });
        } else {
            this.setState({
                activitiesOverdue: _.sortBy(activitiesOverdue, 'dueDate'),
                activitiesToday: _.sortBy(activitiesToday, 'dueDate'),
                activitiesFuture: _.sortBy(activitiesFuture, 'dueDate'),
                activitiesComplete: _.sortBy(activitiesComplete, 'dueDate'),
                activitiesThisWeek: _.sortBy(activitiesThisWeek, 'dueDate'),
                activitiesTomorrow: _.sortBy(activitiesTomorrow, 'dueDate'),
                yourOpenActivityTileStatus: yourOpenActivityTile,
                yourCompletedActivityTileStatus: yourCompletedActivityTile,
                createdByYouActivityTileStatus: createdByYouActivityTile,
                allOpenActivityTileStatus: allOpenActivityTile,
                allCompletedActivityTileStatus: allCompletedActivityTile,
                allCancelledActivityTileStatus: allCancelledActivityTile,
                allUnassignedActivityTileStatus: allUnassignedActivityTile,
                displayNoActivities: false,
            });
        }
        
        this.setState({ currentView: id });
    };

    getSelectedTitle = () => {
        const { toggleAdvancedFilter, currentView } = this.state;

        return toggleAdvancedFilter
            ? tableHeadings[currentView]
            : messages.activities;
    };

    render() {
        const translator = this.context;
        const {
            yourOpenActivityTileStatus,
            yourCompletedActivityTileStatus,
            createdByYouActivityTileStatus,
            allOpenActivityTileStatus,
            allCompletedActivityTileStatus,
            allCancelledActivityTileStatus,
            allUnassignedActivityTileStatus,
            activitiesOverdue,
            activitiesToday,
            activitiesFuture,
            activitiesComplete,
            displayNoActivities,
            activitiesThisWeek,
            activitiesTomorrow,
            activitiesYourOpenCount,
            activitiesCanceledCount,
            activitiesUnassignedCount,
            activitiesAllOpenCount,
            activitiesAllCompletedCount,
            activitiesCreatedByYouCount,
            activitiesYourCompleteCount,
            toggleAdvancedFilter,
            currentView,
            isLoading,
            activitiesResult,
            publicId,
            searchFilter,
        } = this.state;

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            yourOpenActivityTile: {
                value: activitiesYourOpenCount,
                active: yourOpenActivityTileStatus,
            },
            yourCompletedActivityTile: {
                value: activitiesYourCompleteCount,
                active: yourCompletedActivityTileStatus,
            },
            createdByYouActivityTile: {
                value: activitiesCreatedByYouCount,
                active: createdByYouActivityTileStatus,
                visible: false,
            },
            allOpenActivityTile: {
                value: activitiesAllOpenCount,
                active: allOpenActivityTileStatus,
            },
            allCompletedActivityTile: {
                value: activitiesAllCompletedCount,
                active: allCompletedActivityTileStatus,
            },
            allCancelledActivityTile: {
                value: activitiesCanceledCount,
                active: allCancelledActivityTileStatus,
                visible: false,
            },
            allUnassignedActivityTile: {
                value: activitiesUnassignedCount,
                active: allUnassignedActivityTileStatus
            },
            noActivitySeparator: {
                visible: displayNoActivities !== false,
            },
            selectedPoliciyTitle: {
                content: translator(this.getSelectedTitle()),
            },
            advancedFilter: {
                activities: activitiesResult,
                selectedTile: currentView,
                visible: !toggleAdvancedFilter,
            },
            advanceFilterLink: {
                visible: toggleAdvancedFilter,
            },
            quickFilterLink: {
                visible: !toggleAdvancedFilter,
            },
            quickFilterContainer: {
                visible: toggleAdvancedFilter,
            },
            activitiesTableWrapper: {
                className: cx(styles.gwActivitiesTableWrapper, {
                    [styles.gwAdvancedFilterTableContainer]:
                        toggleAdvancedFilter,
                    [styles.gwQuickFilterTableContainer]: !toggleAdvancedFilter,
                }),
            },
            activitiesTableContainer: {
                activitiesOverdue,
                activitiesToday,
                activitiesTomorrow,
                activitiesThisWeek,
                activitiesFuture,
                activitiesComplete,
                displayNoActivities,
                createNote: this.createNote,
                onClickComplete: this.onClickComplete,
                publicId,
                hideCompleteButton: currentView === 'allUnassignedActivityTile'
            },
            searchFilter: {
                value: searchFilter,
            },
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                advancedfilter: ActivityAdvancedFilter,
                activitytablecomponent: ActivityTableComponent,
            },
            resolveCallbackMap: {
                handleOnClick: this.handleOnClick,
                handleFilterClick: this.handleFilterClick,
                handleCustomFilterClick: this.handleCustomFilterClick,
                handleSearchValueChange: value => this.handleFilterChange(value, 'searchFilter'),
            },
        };

        return (
            <div className={styles.activities}>
                <MetadataContent
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    {...resolvers}
                />
            </div>
        );
    }
}

export const ActivitiesComponent = withModalContext(Activities);
export default withAuthenticationContext(withModalContext(Activities));
